import React, { useEffect, useState } from "react";
import propertyService from "reduxStore/service/propertyService";
import { isValidMongoObjectId, normalizeMongoId } from "utils/utils";

// Loads GRE banner via authenticated API blob URL (private S3, not direct CloudFront).
const GreBannerImage = ({
  propertyId,
  propertyTitle = "",
  className = "",
  withShell = false,
  fullWidth = false,
  imageClassName = "",
  imageStyle = {},
}) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    let objectUrl = "";
    let cancelled = false;

    const loadBanner = async () => {
      const normalizedPropertyId = normalizeMongoId(propertyId);
      if (!isValidMongoObjectId(normalizedPropertyId)) {
        if (!cancelled) {
          setImageSrc(null);
        }
        return;
      }

      try {
        const response = await propertyService.getGreBannerImageBlob({
          property_id: normalizedPropertyId,
          suppressGlobalLoader: true,
        });
        if (cancelled || response?.noBanner || !response?.data) {
          if (!cancelled) {
            setImageSrc(null);
          }
          return;
        }
        objectUrl = URL.createObjectURL(response.data);
        setImageSrc(objectUrl);
      } catch (error) {
        if (!cancelled) {
          setImageSrc(null);
        }
      }
    };

    loadBanner();

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [propertyId]);

  if (!imageSrc) {
    return null;
  }

  const image = (
    <img
      src={imageSrc}
      alt={
        propertyTitle
          ? `${propertyTitle} property branding`
          : "Property branding"
      }
      className={imageClassName || className}
      style={imageStyle}
    />
  );

  if (!withShell) {
    return image;
  }

  const columnClass = fullWidth
    ? "col-12"
    : "col-12 col-md-10 col-lg-8";

  return (
    <div
      className={`row justify-content-center mb-4 ${className}`.trim()}
    >
      <div className={columnClass}>
        <div className="gre-banner-shell">
          {image}
        </div>
      </div>
    </div>
  );
};

export default GreBannerImage;
